import { isBoolean } from 'lodash';
import React from 'react';
import { FormGroup } from 'react-bootstrap';

export function Radio(props) {
  const { fieldName, rowIndex, colIndex, onChange, tableIndex, options, CustomAddEditAccess, isProductArchived } = props;

  return (
    <FormGroup className="flex-fill position-relative">
      <div>
        <div className="align-items-center">
          {options?.map((opt, opIndex) => {
            return (
              <p className="custom-radio my-1 mx-3" key={`${opt?.uniqueKey}`}>
                <input
                  type="radio"
                  id={`${opt?.name}_${opIndex}_${tableIndex}_${rowIndex}_${colIndex}`}
                  value={opt?.name}
                  disabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
                  checked={opt?.isChecked || opt?.value || false}
                  name={`${fieldName}_${rowIndex}_${tableIndex}_${colIndex}`}
                  onChange={(e) => onChange(e.target.checked, rowIndex, colIndex, opt?.name)}
                />
                <label className="m-0" htmlFor={`${opt?.name}_${opIndex}_${tableIndex}_${rowIndex}_${colIndex}`}>
                  {opt?.name || opt?.label}
                </label>
              </p>
            );
          })}
        </div>
      </div>
    </FormGroup>
  );
}
export default Radio;
